/* eslint-disable react/no-children-prop */
import {
  Box,
  InputAdornment,
  Typography,
} from '@mui/material';
import React from 'react';
import {
  PrimarySelect,
  PrimaryTextField,
  StickyHeader,
} from 'components';
import { SearchIcon } from 'assets/icons';
import WalletChart from './components/WalletChart';
import EarningsBreakDown from './components/EarningsBreakDown';
import EarningsTable from './components/EarningsTable';

const WalletOverView = () => {
  const sortByOptions = [{ id: 1, value: 'Default', text: 'Default' }, { id: 2, value: 'title-asc', text: 'Name ascending' }, { id: 3, value: 'title-desc', text: 'Name descending' },
    { id: 4, value: 'date-asc', text: 'Date Added ascending' }, { id: 5, value: 'date-desc', text: 'Date Added descending' }];

  const sortByRegion = [{ id: 1, value: 'USA', text: 'USA' }, { id: 5, value: 'AUSTRALIA', text: 'AUSTRALIA' }];

  const [keyword, setKeyword] = React.useState<string>('');
  const [selectedSortBy, setSelectedSortBy] = React.useState<string>(sortByOptions[0].value);
  const [selectSortByRegion, setSortByRegion] = React.useState<string>(sortByRegion[0].value);

  const handleSearchChange = (event: any) => {
    setKeyword(event.target.value);
  };
  const handleSortByChange = (event: any) => {
    setSelectedSortBy(event.target.value);
  };
  const handleSortByChangeRegion = (event:any) => {
    setSortByRegion(event.target.value);
  };

  return (
    <>
      <StickyHeader>
        <div className="row mb-2">
          <div className=" col-lg-3 col-xl-2 mb-3 mb-md-0 d-flex flex-column justify-content-center">
            <Typography variant="h4" sx={{ mb: 0.5 }}>
              Wallet
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Overview of your wallet and income.
            </Typography>
          </div>
          <div className="col-lg-9 col-xl-10">
            <div className="row justify-content-lg-end gy-2 align-items-center gx-3 gx-lg-4">
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <PrimaryTextField
                  placeholder="Search"
                  endAdornment={(
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )}
                  value={keyword}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <PrimarySelect
                  inlineLabel
                  label="Sort"
                  options={sortByOptions}
                  onChange={handleSortByChange}
                  value={selectedSortBy}
                />
              </div>
              <div className="col-sm-4 col-lg-4 col-xl-3 mb-2 mb-md-0">
                <PrimarySelect
                  inlineLabel
                  label="Region"
                  options={sortByRegion}
                  onChange={handleSortByChangeRegion}
                  value={selectSortByRegion}
                />
              </div>
            </div>
          </div>
        </div>
      </StickyHeader>
      <div className="row">
        <WalletChart />
        <EarningsBreakDown />
      </div>
      <Box sx={{
        borderRadius: 1.5,
        backgroundColor: 'background.paper',
        p: 0,
        mt: 5,
      }}
      >
        <Box sx={{ p: 3 }}>
          <Typography>Earning history</Typography>
        </Box>
        <EarningsTable />
      </Box>
    </>
  );
};

export default WalletOverView;
